import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    baseURL: "https://api.ledianyun.com/", //正式
    testURL: "https://api.store.ledianyun.com/",//正式
    // baseURL: "http://api.test.ledianyun.com/", //测试
    // testURL: "http://api.store.test.ledianyun.com/",//测试
    ledianyunURL: "http://api.ledianyun.com/",//正式

  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
